import { Route } from '@angular/router';
import { InitialDataResolver } from 'app/app.resolvers';
import { ApplicationsManualStatisticsComponent } from 'app/components/applications/manual-statistics/applications-manual-statistics.component';
import { PensionOtherFundsComponent } from 'app/components/applications/pension-other-funds/pension-other-funds.component';
import { AssistsInterestRegisterComponent } from 'app/components/assists/interest-register/assists-interest-register.component';
import { InterestRegisterDetailComponent } from 'app/components/assists/interest-register/components/interest-register-detail/interest-register-detail.component';
import { InterestRegisterFormComponent } from 'app/components/assists/interest-register/components/interest-register-form/interest-register-form.component';
import { InterestRegisterListComponent } from 'app/components/assists/interest-register/components/interest-register-list/interest-register-list.component';
import { AssistsJiraStsComponent } from 'app/components/assists/jira/sts/assists-jira-sts.component';
import { BakvordurComponent } from 'app/components/bakvordur/bakvordur.component';
import { JobDetailsComponent } from 'app/components/jobs/job-details.component';
import { LoansFMEReport } from 'app/components/loans/fme-report/loans-fme-report.component';
import { LoansMortgageEligibilityFormListComponent } from 'app/components/loans/mortgage-eligibility/mortgage-eligibility-form-list/loans-mortgage-eligibility-form-list.component';
import { LogsComponent } from 'app/components/logs/logs.component';
import { PensionCoefficientsComponent } from 'app/components/pension/coefficients/pension-coefficients.component';
import { PensionDivisionOfRulingsComponent } from 'app/components/pension/division-of-rulings/pension-division-of-rulings.component';
import { PensionIncreaseClaimsComponent } from 'app/components/pension/increase-claims/pension-increase-claims.component';
import { PensionPaycheckRunsComponent } from 'app/components/pension/paychecks/pension-paycheck-runs.component';
import { PensionPaycheckRunsPrintComponent } from 'app/components/pension/paychecks/print/pension-paycheck-runs-print.component';
import { PendingTaxUpdatesComponent } from 'app/components/pension/pending-tax-updates/pending-tax-updates.component';
import { PensionStateResponsibilityGroupComponent } from 'app/components/pension/state-responsibility-group/pension-state-responsibility-group.component';
import { XMLValidationComponent } from 'app/components/xml-validation/xml-validation.component';
import { AssistAzureComponent } from '../components/assists/azure/assists-azure.component';
import { AssistsJiraAtvikComponent } from '../components/assists/jira/atvik/assists-jira-atvik.component';
import { AssistsJiraBvhComponent } from '../components/assists/jira/bvh/assists-jira-bvh.component';
import { AssistsJiraEAComponent } from '../components/assists/jira/ea/assists-jira-ea.component';
import { AssistsJiraUtComponent } from '../components/assists/jira/ut/assists-jira-ut.component';
import { AssistsOverviewComponent } from '../components/assists/overview/assists-overview.component';
import { AudkenningSendaBeidniComponent } from '../components/audkenning/senda-beidni/audkenning-senda-beidni.component';
import { AudkenningSkodaBeidnirComponent } from '../components/audkenning/skoda-beidnir/audkenning-skoda-beidnir.component';
import { DocumentsComponent } from '../components/documents/documents.component';
import { GengiSkraComponent } from '../components/gengi/skra/gengi-skra.component';
import { GroupsComponent } from '../components/groups/groups.component';
import { AzureEnvironmentReservationsComponent } from '../components/it/azure-environment-reservations/azure-environment-reservations.component';
import { LoansMortgageEligibilityFormComponent } from '../components/loans/mortgage-eligibility/mortgage-eligibiliy-form/loans-mortgage-eligibility-form.component';
import { ReportsPowerBIComponent } from '../components/reports/powerbi/reports-powerbi.component';
import { SettingsComponent } from '../components/settings/settings.component';
import { SettingsUsersUserComponent } from '../components/settings/users/user/settings-users-user.component';
import { ThjodskraComponent } from '../components/thjodskra/thjodskra.component';
import { AuthGuard } from '../fuse-template/core/auth/guards/auth.guard';
import { NoAuthGuard } from '../fuse-template/core/auth/guards/noAuth.guard';
import { LayoutComponent } from '../fuse-template/layout/base-layout/layout.component';
import { PendingChangesGuard } from '../helpers/pendingChangesGuard';
import { DocumentsAddDropdownDataResolver } from './resolvers/documents-add-dropdown-data-resolver';
import { MortgageEligibilityConfigResolver } from './resolvers/mortgageEligibilityConfigResolver';

// ------------- README:
// If a public url is being created make sure to add the url to "dontCheckUrls()" function is app.component.ts !!!!!

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const AppRoutes: Route[] = [
    //#region Theme
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'stillingar/profill' },

    // Redirect signed in user to the '/example'
    //
    // After the user signs in, the sign in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'stillingar/profill',
    },
    {
        path: 'stadfesting-netfangs/:token',
        pathMatch: 'full',
        redirectTo: 'notandi/stadfesting-netfangs/:token',
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'innskra',
                loadChildren: () => import('app/fuse-template/modules/auth/sign-in/sign-in.module').then((m) => m.AuthSignInModule),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'utskra',
                loadChildren: () => import('app/fuse-template/modules/auth/sign-out/sign-out.module').then((m) => m.AuthSignOutModule),
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import('app/fuse-template/modules/auth/unlock-session/unlock-session.module').then((m) => m.AuthUnlockSessionModule),
            },
        ],
    },

    //#endregion

    //#region LSR

    {
        path: 'vefstillingar',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: ':panel',
                component: SettingsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: ':panel/:panel2',
                component: SettingsComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'maelabord-og-skyrslur',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: '',
                component: ReportsPowerBIComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'stillingar',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: ':panel',
                component: SettingsUsersUserComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: ':panel/:panel2',
                component: SettingsUsersUserComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'skjalasafn',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
            dropdownData: DocumentsAddDropdownDataResolver,
        },
        children: [
            {
                path: '',
                component: DocumentsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: ':panel',
                component: DocumentsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: ':panel/:panel2',
                component: DocumentsComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'vinnslur',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: ':id',
                component: JobDetailsComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'hopar',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: '',
                component: GroupsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: ':selectedGroupId',
                component: GroupsComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'lan',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'fme-skil',
                component: LoansFMEReport,
            },
            {
                path: 'vedhaefi',
                component: LoansMortgageEligibilityFormListComponent,
            },
            {
                path: 'vedhaefi/:id',
                component: LoansMortgageEligibilityFormComponent,
                canDeactivate: [PendingChangesGuard],
                resolve: {
                    config: MortgageEligibilityConfigResolver,
                },
            },
        ],
    },
    {
        path: 'lifeyrir',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'lifeyrishaekkanir',
                component: PensionIncreaseClaimsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'rikisabyrgdarhopur-uppgjor',
                component: PensionStateResponsibilityGroupComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'umsoknir/tolfraedi',
                component: ApplicationsManualStatisticsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'umsoknir/adrir-sjodir',
                component: PensionOtherFundsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'studlar',
                component: PensionCoefficientsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'adgreining-urskurda',
                component: PensionDivisionOfRulingsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'launasedlavinnslur',
                component: PensionPaycheckRunsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'launasedlavinnslur/prent',
                component: PensionPaycheckRunsPrintComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'skattaupplysingar-i-bid',
                component: PendingTaxUpdatesComponent,
            },
        ],
    },
    {
        path: 'gengi',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'skra-gengi',
                component: GengiSkraComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'skra-gengi-ohad',
                component: GengiSkraComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'atvik-og-beidnir',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'yfirlit',
                component: AssistsOverviewComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'atvikatilkynningar',
                children: [
                    {
                        path: '',
                        component: AssistsJiraAtvikComponent,
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'min-atvik',
                        component: AssistsJiraAtvikComponent,
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
            {
                path: 'tolvuadstod-og-breytingabeidnir/:panel',
                component: AssistAzureComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'adgangsbeidnir',
                children: [
                    {
                        path: '',
                        component: AssistsJiraUtComponent,
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'skra-beidni',
                        component: AssistsJiraUtComponent,
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'minar-beidnir',
                        component: AssistsJiraUtComponent,
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
            {
                path: 'styrkir/:panel',
                component: AssistsJiraStsComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'husnaedi/:panel',
                component: AssistsJiraBvhComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'eftirlitsadgerdir/:panel',
                component: AssistsJiraEAComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'hagsmunaskra',
                children: [
                    {
                        path: '',
                        component: AssistsInterestRegisterComponent,
                    },
                    {
                        path: 'ny-skraning/:entryType',
                        component: InterestRegisterFormComponent,
                        canDeactivate: [PendingChangesGuard],
                    },
                    {
                        path: 'minar-skraningar',
                        component: InterestRegisterListComponent,
                    },
                    {
                        path: 'minar-skraningar/:id',
                        component: InterestRegisterDetailComponent,
                    },
                    {
                        path: 'skraningar',
                        component: InterestRegisterListComponent,
                    },
                    {
                        path: 'skraningar/:id',
                        component: InterestRegisterDetailComponent,
                    },
                ],
            },
        ],
    },
    {
        path: 'rafraen-audkenning',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'senda-audkenningarbeidni',
                component: AudkenningSendaBeidniComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: 'skoda-audkenningar',
                component: AudkenningSkodaBeidnirComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'thjodskra-og-fyrirtaekjaskra',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: '',
                component: ThjodskraComponent,
                canDeactivate: [PendingChangesGuard],
            },
            {
                path: ':tab',
                component: ThjodskraComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'breytingasaga',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: '',
                component: LogsComponent,
                canDeactivate: [PendingChangesGuard],
            },
        ],
    },
    {
        path: 'villuathugun',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'xml-xsd',
                component: XMLValidationComponent,
            },
        ],
    },
    {
        path: 'it',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: 'fratektir-azure-umhverfa',
                component: AzureEnvironmentReservationsComponent,
            },
        ],
    },
    {
        path: 'bakvordur',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
            {
                path: '',
                component: BakvordurComponent,
            },
        ],
    },

    //#endregion
];
